<template>
  <div class="">
    <div class="content bg-white rounded border shadow p-3 position-relative container">
      <h5>Precios</h5>
      <hr />
      <!-- New Day Detalle -->
      <div class="row">
        <div class="col">
          <label for="precios1" class="me-1 text-nowrap">Habitación 1</label><br />

          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon1">$</span>
            <input type="number" step="1" class="form-control" aria-describedby="basic-addon1"
              v-model="precios.monto1" />
          </div>
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon2"><i class="fa fa-male" aria-hidden="true"></i>
            </span>
            <input type="number" step="1" class="form-control" aria-describedby="basic-addon2"
              v-model="precios.cantidad1" />
          </div>
        </div>
        <div class="col" style="border-left: #CACFD3 1px solid;">
          <label for="precios2" class="me-1 text-nowrap">Habitación 2</label><br />

          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon3">$</span>
            <input type="number" step="1" class="form-control" aria-describedby="basic-addon3"
              v-model="precios.monto2" />
          </div>
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon4"><i class="fa fa-male" aria-hidden="true"></i>
            </span>
            <input type="number" step="1" class="form-control" aria-describedby="basic-addon4"
              v-model="precios.cantidad2" />
          </div>
        </div>
        <div class="col" style="border-left: #CACFD3 1px solid;">
          <label for="precios3" class="me-1 text-nowrap">Habitación 3</label><br />

          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon5">$</span>
            <input type="number" step="1" class="form-control" aria-describedby="basic-addon5"
              v-model="precios.monto3" />
          </div>
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon6"><i class="fa fa-male" aria-hidden="true"></i>
            </span>
            <input type="number" step="1" class="form-control" aria-describedby="basic-addon6"
              v-model="precios.cantidad3" />
          </div>
        </div>
        <div class="col" style="border-left: #CACFD3 1px solid;">
          <label for="precios4" class="me-1 text-nowrap">Habitación 4</label><br />

          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon7">$</span>
            <input type="number" step="1" class="form-control" aria-describedby="basic-addon7"
              v-model="precios.monto4" />
          </div>
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon8"><i class="fa fa-male" aria-hidden="true"></i>
            </span>
            <input type="number" step="1" class="form-control" aria-describedby="basic-addon8"
              v-model="precios.cantidad4" />
          </div>
        </div>
        <div class="col" style="border-left: #CACFD3 1px solid;">
          <label for="preciosAcampe" class="me-1">Acampe</label><br />

          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon9">$</span>
            <input type="number" step="1" class="form-control" aria-describedby="basic-addon9"
              v-model="precios.montoAcampe" />
          </div>
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon10"><i class="fa fa-male" aria-hidden="true"></i>
            </span>
            <input type="number" step="1" class="form-control" aria-describedby="basic-addon10"
              v-model="precios.cantidadAcampe" />
          </div>
        </div>
        <div class="col" style="border-left: #CACFD3 1px solid;">
          <label for="preciosAcampe" class="me-1">Reserva</label><br />
          <div class="input-group mb-3">
            <input type="number" step="1" class="form-control" aria-describedby="basic-addon9"
              v-model="precios.porcentajeReserva" />
            <span class="input-group-text" id="basic-addon9">%</span>
          </div>
        </div>
      </div>
      <hr />
      <div class="input-group mb-3">
        <span class="input-group-text" id="basic-addon1">API KEY Mercado Pago</span>
        <input type="text" class="form-control" v-model="precios.apiKeyMercadoPago">
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon1">Email Admin</span>
            <input type="text" class="form-control" v-model="precios.emailAdmin" placeholder="mail.admin@gmail.com">
          </div>
        </div>
        <div class="col-12 col-md-6 d-none">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon1">Acceso al Cerro</span>
            <input type="number" class="form-control" v-model="precios.accesoCerro">
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addon1">Teléfono</span>
            <input type="text" class="form-control" v-model="precios.telefono">
          </div>
          <small>(El teléfono debe tener el prefijo 549 y estar sin 0 ni 15 Ejemplo: 5492932496418)</small>
        </div>
      </div>
      
      <!-- New Day Buttons-->
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-success" @click="precioUpdate">Guardar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  name: 'HomeView',
  mounted() {
    this.precioGet();
  },
  data() {
    return {
      precios: {
        monto1: null,
        cantidad1: null,
        monto2: null,
        cantidad2: null,
        monto3: null,
        cantidad3: null,
        monto4: null,
        cantidad4: null,
        montoAcampe: null,
        cantidadAcampe: null,
        porcentajeReserva: null,
        apiKeyMercadoPago: '',
        telefono: '',
        emailAdmin: '',
        accesoCerro: ''
      },
    };
  },
  methods: {
    ...mapActions("precio", ["precio_get", "precio_update"]),
    async precioGet() {
      try {
        let response = await this.precio_get();

        if (response.status == 200) {
          this.precios.montoAcampe = response.data.acampe.monto;
          this.precios.cantidadAcampe = response.data.acampe.cantidad;

          this.precios.monto1 = response.data.complejo1.monto;
          this.precios.cantidad1 = response.data.complejo1.cantidad;

          this.precios.monto2 = response.data.complejo2.monto;
          this.precios.cantidad2 = response.data.complejo2.cantidad;

          this.precios.monto3 = response.data.complejo3.monto;
          this.precios.cantidad3 = response.data.complejo3.cantidad;

          this.precios.monto4 = response.data.complejo4.monto;
          this.precios.cantidad4 = response.data.complejo4.cantidad;

          this.precios.porcentajeReserva = response.data.porcentaje_reserva.value;
          this.precios.apiKeyMercadoPago = response.data.api_key_mercado_pago.value;
          this.precios.telefono = response.data.telefono.value;
          this.precios.emailAdmin = response.data.emailAdmin.value;
          this.precios.accesoCerro = response.data.accesoCerro.value;

        }
      } catch (error) {
        console.log(error);
        toast.error('Error obteniendo los precios');
      }
    },
    async precioUpdate() {
      try {
        let response = await this.precio_update(this.precios);

        if (response.status == 200) {
          toast.success('Precios actualizados con éxito');
          await this.precioGet();
        }
      } catch (error) {
        console.log(error);
        toast.error('Error al actualizar los precios');
      }
    }
  },

};
</script>

<style scoped></style>
